import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "../../Icons";

/**
 * Full-bleed campaign photo. Each slide supplies its own project-related image.
 */
const PromoHeroArt = ({
  src,
  alt = "",
  onPrev,
  onNext,
  canPrev = false,
  canNext = false,
}) => (
  <div className="relative h-44 sm:h-52 overflow-hidden bg-indigo-100">
    {src ? (
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-cover object-[center_30%]"
      />
    ) : null}
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-slate-900/40 via-slate-900/5 to-black/25" />

    {canPrev ? (
      <button
        type="button"
        onClick={onPrev}
        className="absolute left-3 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-700 shadow-sm hover:bg-white"
        aria-label="Previous slide"
      >
        <ChevronLeftIcon size={16} />
      </button>
    ) : null}
    {canNext ? (
      <button
        type="button"
        onClick={onNext}
        className="absolute right-3 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-700 shadow-sm hover:bg-white"
        aria-label="Next slide"
      >
        <ChevronRightIcon size={16} />
      </button>
    ) : null}
  </div>
);

export default PromoHeroArt;
